import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useAsync } from 'react-use';
import type { CompoundEntityRef } from '@backstage/catalog-model';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { fetchSystemsForDomain } from '../catalog/hierarchy';

export function useSystemEntities(domainRef: CompoundEntityRef | undefined) {
  const catalogApi = useApi(catalogApiRef);
  const domainRefString = domainRef ? stringifyEntityRef(domainRef) : undefined;

  const { value, loading, error } = useAsync(async () => {
    return fetchSystemsForDomain(catalogApi, domainRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catalogApi, domainRefString]);

  return {
    items: value ?? [],
    loading,
    error,
  };
}
